export const translations = {
  es: {
    // Login
    login: {
      title: 'Klorum',
      subtitle: 'Sistema CRM Potenciado con Inteligencia Artificial',
      email: 'Correo electrónico',
      password: 'Contraseña',
      loginButton: 'Iniciar Sesión',
      noAccount: '¿No tienes cuenta?',
      signupLink: 'Regístrate aquí',
      forgotPassword: '¿Olvidaste tu contraseña?',
      errorLogin: 'Error al iniciar sesión',
      orContinueWith: 'O continúa con',
      loginWithFacebook: 'Continuar con Facebook',
      loginWithGoogle: 'Continuar con Google',
      comingSoonFacebook: 'Próximamente: Login con Facebook',
      comingSoonGoogle: 'Próximamente: Login con Google',
    },
    landing: {
      badge: 'Plataforma comercial 3D',
      title: 'Vende, automatiza y escala en una sola plataforma',
      subtitle: 'Centraliza WhatsApp, llamadas y seguimiento con control en tiempo real.',
      nav: {
        benefits: 'Beneficios',
        market: 'Mercado',
        pricing: 'Precios',
        contact: 'Contacto',
      },
      quickPills: {
        speed: 'Respuestas en segundos',
        control: 'Control operativo diario',
        conversión: 'Mas cierres por equipo',
      },
      servicesTitle: 'Servicios base',
      services: {
        omnichannelTitle: 'Atención omnicanal',
        omnichannelDescription: 'Unifica chats y llamadas en una sola bandeja.',
        automationTitle: 'Automatización inteligente',
        automationDescription: 'Reglas y flujos para responder sin fricción.',
        analyticsTitle: 'Analítica comercial',
        analyticsDescription: 'Mide rendimiento y conversiones en tiempo real.',
        supportTitle: 'Control operativo',
        supportDescription: 'Asigna tareas y da seguimiento por responsable.',
      },
      benefitsTitle: 'Beneficios clave',
      benefitsSubtitle: 'Todo el flujo comercial en menos pasos y con datos claros.',
      benefits: {
        centralizedTitle: 'Operación centralizada',
        centralizedDescription: 'Mensajes, llamadas y tareas en la misma vista.',
        responseTitle: 'Respuesta rápida',
        responseDescription: 'Plantillas y disparadores para atender al instante.',
        followupTitle: 'Seguimiento constante',
        followupDescription: 'Recordatorios y estados para no perder oportunidades.',
        visibilityTitle: 'Visión en tiempo real',
        visibilityDescription: 'Paneles con actividad, embudo y conversión diaria.',
        teamworkTitle: 'Trabajo en equipo',
        teamworkDescription: 'Distribuye conversaciones y mide carga por agente.',
        governanceTitle: 'Control y seguridad',
        governanceDescription: 'Permisos por rol y trazabilidad de cada acción.',
      },
      market: {
        title: 'Zona de mercado',
        subtitle: 'Activa módulos según tu etapa y paga solo lo necesario.',
        items: {
          automationTitle: 'Flujos y procesos',
          automationDescription: 'Automatiza ventas, soporte y postventa.',
          aiTitle: 'IA comercial',
          aiDescription: 'Asistentes, prompts y respuestas sugeridas.',
          integrationsTitle: 'Integraciones',
          integrationsDescription: 'Conecta API, canales y herramientas externas.',
          billingTitle: 'Cobros y membresías',
          billingDescription: 'Gestiona planes, renovaciones y crecimiento.',
        },
        ctaHint: 'Ingresa para habilitar módulos desde tu panel Mercado.',
        ctaButton: 'Entrar y activar módulos',
      },
      actions: {
        login: 'Ingresar a la aplicacion',
        whatsapp: 'Escribir por WhatsApp',
        call: 'Llamar ahora',
      },
      contactLabel: 'Contacto Klorum: {{number}}',
      redirectHint: 'Todos los accesos de la plataforma redirigen al login seguro.',
      footer: {
        rights: 'Klorum {{year}}. Todos los derechos reservados.',
        note: 'Acceso comercial por login seguro.',
      },
    },
    // Signup
    signup: {
      title: 'Crear Cuenta',
      subtitle: 'Únete a Klorum',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      company: 'Empresa (opcional)',
      phone: 'Teléfono (opcional)',
      signupButton: 'Registrarse',
      hasAccount: '¿Ya tienes cuenta?',
      loginLink: 'Inicia sesión aquí',
      terms: 'Al registrarte, aceptas nuestros',
      termsLink: 'Términos y Condiciones',
      and: 'y',
      privacyLink: 'Política de Privacidad',
      errorSignup: 'Error al registrarse',
      passwordMismatch: 'Las contraseñas no coinciden',
    },
    forgotPassword: {
      title: 'Restablecer contraseña',
      email: 'Escribe tu correo electrónico',
      sendLink: 'Enviar enlace de restablecimiento',
      sending: 'Enviando...',
      sent: 'Enviado',
      backToLogin: 'Volver al login',
      toasts: {
        success: 'Enlace de restablecimiento enviado con éxito',
      },
    },
    resetPassword: {
      title: 'Restablecer contraseña',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      resetButton: 'Restablecer contraseña',
      resetting: 'Restableciendo...',
      resetDone: 'Restablecida',
      backToLogin: 'Volver al login',
      toasts: {
        success: 'Contraseña restablecida con éxito',
      },
      errors: {
        missingOrInvalidToken:
          'Token de restablecimiento ausente o inválido. Por favor solicita un nuevo enlace.',
        passwordMismatch: 'Las contraseñas no coinciden',
        passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
        resetFailed: 'Error al restablecer la contraseña. Inténtalo de nuevo.',
      },
    },
    tickets: {
      inbox: {
        sortAscending: 'Ascendente',
        sortDescending: 'Descendente',
      },
    },
    registerClient: {
      title: 'Registrar cliente',
      subtitle: 'Crea una nueva cuenta cliente y define su plan inicial.',
      steps: {
        company: 'Empresa',
        contact: 'Contacto',
        plan: 'Plan y módulos',
      },
      toasts: {
        stepCompanyRequired: 'Completa nombre, correo y teléfono de la empresa.',
        stepContactRequired: 'Completa nombre y correo del contacto.',
        success: 'Cliente registrado con éxito.',
        error: 'No se pudo registrar el cliente.',
      },
      industries: {
        retail: 'Retail',
        restaurant: 'Restaurante',
        healthcare: 'Salud',
        education: 'Educacion',
        technology: 'Tecnologia',
        services: 'Servicios',
        ecommerce: 'Ecommerce',
        realEstate: 'Inmobiliaria',
        other: 'Otro',
      },
      company: {
        title: 'Datos de la empresa',
        fields: {
          name: 'Nombre de la empresa',
          industry: 'Industria',
          email: 'Correo de la empresa',
          phone: 'Teléfono de la empresa',
          address: 'Direccion',
          website: 'Sitio web',
        },
      },
      contact: {
        title: 'Persona de contacto',
        fields: {
          name: 'Nombre completo',
          position: 'Cargo',
          email: 'Correo',
          phone: 'Teléfono',
        },
      },
      plan: {
        title: 'Plan y facturacion',
        perMonth: '/mes',
        includes: {
          users: 'Usuarios',
          connections: 'Conexiónes',
          queues: 'Areas',
        },
        billingCycle: 'Ciclo de facturacion',
        billingMonthly: 'Mensual',
        billingAnnual: 'Anual (2 meses gratis)',
      },
      addons: {
        title: 'Módulos adicionales',
        pricePerMonth: '$ {{amount}}/mes',
      },
      notes: {
        title: 'Notas internas',
        placeholder: 'Escribe observaciones para el equipo comercial...',
      },
      total: {
        label: 'Total estimado',
        perMonth: ' /mes',
        perYear: ' /anio',
      },
      buttons: {
        back: 'Volver',
        next: 'Siguiente',
        submit: 'Registrar cliente',
      },
    },
  },
  en: {
    // Login
    login: {
      title: 'Klorum',
      subtitle: 'AI-Powered CRM System',
      email: 'Email',
      password: 'Password',
      loginButton: 'Sign In',
      noAccount: "Don't have an account?",
      signupLink: 'Sign up here',
      forgotPassword: 'Forgot your password?',
      errorLogin: 'Login error',
      orContinueWith: 'Or continue with',
      loginWithFacebook: 'Continue with Facebook',
      loginWithGoogle: 'Continue with Google',
      comingSoonFacebook: 'Coming soon: Login with Facebook',
      comingSoonGoogle: 'Coming soon: Login with Google',
    },
    landing: {
      badge: '3D Commercial Platform',
      title: 'Sell, automate, and scale from one platform',
      subtitle: 'Centralize WhatsApp, calls, and follow-up with real-time control.',
      nav: {
        benefits: 'Benefits',
        market: 'Marketplace',
        pricing: 'Pricing',
        contact: 'Contact',
      },
      quickPills: {
        speed: 'Replies in seconds',
        control: 'Daily operation control',
        conversión: 'More closed deals',
      },
      servicesTitle: 'Core services',
      services: {
        omnichannelTitle: 'Omnichannel support',
        omnichannelDescription: 'Unify chats and calls in one inbox.',
        automationTitle: 'Smart automation',
        automationDescription: 'Rules and flows to respond without friction.',
        analyticsTitle: 'Sales analytics',
        analyticsDescription: 'Track performance and conversión in real time.',
        supportTitle: 'Operational control',
        supportDescription: 'Assign tasks and follow each opportunity.',
      },
      benefitsTitle: 'Key benefits',
      benefitsSubtitle: 'Run your full sales flow in fewer steps with clear data.',
      benefits: {
        centralizedTitle: 'Centralized operation',
        centralizedDescription: 'Messages, calls, and tasks in the same view.',
        responseTitle: 'Fast response',
        responseDescription: 'Templates and triggers to serve clients instantly.',
        followupTitle: 'Consistent follow-up',
        followupDescription: 'Reminders and status tracking to avoid lost deals.',
        visibilityTitle: 'Real-time visibility',
        visibilityDescription: 'Dashboards for activity, funnel, and daily conversión.',
        teamworkTitle: 'Team collaboration',
        teamworkDescription: 'Distribute conversations and balance agent workload.',
        governanceTitle: 'Control and security',
        governanceDescription: 'Role-based permissions and full action traceability.',
      },
      market: {
        title: 'Marketplace zone',
        subtitle: 'Enable modules by growth stage and pay only for what you need.',
        items: {
          automationTitle: 'Flows and processes',
          automationDescription: 'Automate sales, support, and post-sale tasks.',
          aiTitle: 'Commercial AI',
          aiDescription: 'Assistants, prompts, and suggested responses.',
          integrationsTitle: 'Integrations',
          integrationsDescription: 'Connect APIs, channels, and external tools.',
          billingTitle: 'Billing and plans',
          billingDescription: 'Manage memberships, renewals, and growth.',
        },
        ctaHint: 'Sign in to enable modules from your Marketplace panel.',
        ctaButton: 'Sign in and enable modules',
      },
      actions: {
        login: 'Enter the app',
        whatsapp: 'Contact via WhatsApp',
        call: 'Call now',
      },
      contactLabel: 'Klorum contact: {{number}}',
      redirectHint: 'All platform access points redirect to the secure login.',
      footer: {
        rights: 'Klorum {{year}}. All rights reserved.',
        note: 'Commercial access through secure login.',
      },
    },
    // Signup
    signup: {
      title: 'Create Account',
      subtitle: 'Join Klorum',
      name: 'Full name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      company: 'Company (optional)',
      phone: 'Phone (optional)',
      signupButton: 'Sign Up',
      hasAccount: 'Already have an account?',
      loginLink: 'Sign in here',
      terms: 'By signing up, you agree to our',
      termsLink: 'Terms and Conditions',
      and: 'and',
      privacyLink: 'Privacy Policy',
      errorSignup: 'Signup error',
      passwordMismatch: 'Passwords do not match',
    },
    forgotPassword: {
      title: 'Reset Password',
      email: 'Enter your email',
      sendLink: 'Send reset link',
      sending: 'Sending...',
      sent: 'Sent',
      backToLogin: 'Back to login',
      toasts: {
        success: 'Password reset link sent successfully',
      },
    },
    resetPassword: {
      title: 'Reset Password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      resetButton: 'Reset password',
      resetting: 'Resetting...',
      resetDone: 'Reset',
      backToLogin: 'Back to login',
      toasts: {
        success: 'Password reset successfully',
      },
      errors: {
        missingOrInvalidToken:
          'Missing or invalid reset token. Please request a new reset link.',
        passwordMismatch: 'Passwords do not match',
        passwordMinLength: 'Password must be at least 6 characters',
        resetFailed: 'Error resetting password. Please try again.',
      },
    },
    tickets: {
      inbox: {
        sortAscending: 'Ascending',
        sortDescending: 'Descending',
      },
    },
    registerClient: {
      title: 'Register client',
      subtitle: 'Create a new client account and define the starting plan.',
      steps: {
        company: 'Company',
        contact: 'Contact',
        plan: 'Plan & modules',
      },
      toasts: {
        stepCompanyRequired: 'Complete company name, email, and phone.',
        stepContactRequired: 'Complete contact name and email.',
        success: 'Client registered successfully.',
        error: 'Could not register client.',
      },
      industries: {
        retail: 'Retail',
        restaurant: 'Restaurant',
        healthcare: 'Healthcare',
        education: 'Education',
        technology: 'Technology',
        services: 'Services',
        ecommerce: 'Ecommerce',
        realEstate: 'Real estate',
        other: 'Other',
      },
      company: {
        title: 'Company details',
        fields: {
          name: 'Company name',
          industry: 'Industry',
          email: 'Company email',
          phone: 'Company phone',
          address: 'Address',
          website: 'Website',
        },
      },
      contact: {
        title: 'Contact person',
        fields: {
          name: 'Full name',
          position: 'Position',
          email: 'Email',
          phone: 'Phone',
        },
      },
      plan: {
        title: 'Plan and billing',
        perMonth: '/month',
        includes: {
          users: 'Users',
          connections: 'Connections',
          queues: 'Areas',
        },
        billingCycle: 'Billing cycle',
        billingMonthly: 'Monthly',
        billingAnnual: 'Yearly (2 free months)',
      },
      addons: {
        title: 'Add-on modules',
        pricePerMonth: '$ {{amount}}/month',
      },
      notes: {
        title: 'Internal notes',
        placeholder: 'Write notes for the sales team...',
      },
      total: {
        label: 'Estimated total',
        perMonth: ' /month',
        perYear: ' /year',
      },
      buttons: {
        back: 'Back',
        next: 'Next',
        submit: 'Register client',
      },
    },
  },
  "pt-BR": {
    // Login
    login: {
      title: 'Klorum',
      subtitle: 'Sistema CRM Potencializado com Inteligência Artificial',
      email: 'E-mail',
      password: 'Senha',
      loginButton: 'Entrar',
      noAccount: 'Não tem uma conta?',
      signupLink: 'Cadastre-se aquí',
      forgotPassword: 'Esqueceu sua senha?',
      errorLogin: 'Erro ao fazer login',
      orContinueWith: 'Ou continue com',
      loginWithFacebook: 'Continuar com Facebook',
      loginWithGoogle: 'Continuar com Google',
      comingSoonFacebook: 'Em breve: Login com Facebook',
      comingSoonGoogle: 'Em breve: Login com Google',
    },
    landing: {
      badge: 'Plataforma comercial 3D',
      title: 'Venda, automatize e escale em uma unica plataforma',
      subtitle: 'Centralize WhatsApp, ligacoes e acompanhamento com controle em tempo real.',
      nav: {
        benefits: 'Beneficios',
        market: 'Mercado',
        pricing: 'Precos',
        contact: 'Contato',
      },
      quickPills: {
        speed: 'Respostas em segundos',
        control: 'Controle operaciónal diario',
        conversión: 'Mais fechamentos por equipe',
      },
      servicesTitle: 'Servicos base',
      services: {
        omnichannelTitle: 'Atendimento omnicanal',
        omnichannelDescription: 'Unifique chats e ligacoes em uma unica caixa.',
        automationTitle: 'Automacao inteligente',
        automationDescription: 'Regras e fluxos para responder sem friccao.',
        analyticsTitle: 'Analise comercial',
        analyticsDescription: 'Meca desempenho e conversao em tempo real.',
        supportTitle: 'Controle operaciónal',
        supportDescription: 'Distribua tarefas e acompanhe cada oportunidade.',
      },
      benefitsTitle: 'Beneficios chave',
      benefitsSubtitle: 'Execute todo o fluxo comercial com menos passos e dados claros.',
      benefits: {
        centralizedTitle: 'Operacao centralizada',
        centralizedDescription: 'Mensagens, ligacoes e tarefas na mesma visao.',
        responseTitle: 'Resposta rápida',
        responseDescription: 'Modelos e gatilhos para atender no instante certo.',
        followupTitle: 'Follow-up constante',
        followupDescription: 'Lembretes e status para nao perder oportunidades.',
        visibilityTitle: 'Visao em tempo real',
        visibilityDescription: 'Painel com atividade, funil e conversao diaria.',
        teamworkTitle: 'Trabalho em equipe',
        teamworkDescription: 'Distribua conversas e equilibre carga por agente.',
        governanceTitle: 'Controle e seguranca',
        governanceDescription: 'Permissoes por perfil e rastreio de cada acao.',
      },
      market: {
        title: 'Zona de mercado',
        subtitle: 'Ative módulos por etapa de crescimento e pague so pelo necessario.',
        items: {
          automationTitle: 'Fluxos e processos',
          automationDescription: 'Automatize vendas, suporte e pos-venda.',
          aiTitle: 'IA comercial',
          aiDescription: 'Assistentes, prompts e respostas sugeridas.',
          integrationsTitle: 'Integracoes',
          integrationsDescription: 'Conecte APIs, canais e ferramentas externas.',
          billingTitle: 'Cobranca e planos',
          billingDescription: 'Gerencie assinaturas, renovacoes e crescimento.',
        },
        ctaHint: 'Entre para ativar módulos no seu painel Mercado.',
        ctaButton: 'Entrar e ativar módulos',
      },
      actions: {
        login: 'Entrar na aplicacao',
        whatsapp: 'Falar pelo WhatsApp',
        call: 'Ligar agora',
      },
      contactLabel: 'Contato Klorum: {{number}}',
      redirectHint: 'Todos os acessos da plataforma redirecionam para o login seguro.',
      footer: {
        rights: 'Klorum {{year}}. Todos os direitos reservados.',
        note: 'Acesso comercial por login seguro.',
      },
    },
    // Signup
    signup: {
      title: 'Criar Conta',
      subtitle: 'Junte-se ao Klorum',
      name: 'Nome completo',
      email: 'E-mail',
      password: 'Senha',
      confirmPassword: 'Confirmar senha',
      company: 'Empresa (opcional)',
      phone: 'Telefone (opcional)',
      signupButton: 'Cadastrar',
      hasAccount: 'Já tem uma conta?',
      loginLink: 'Faça login aquí',
      terms: 'Ao se cadastrar, você concorda com nossos',
      termsLink: 'Termos e Condições',
      and: 'e',
      privacyLink: 'Política de Privacidade',
      errorSignup: 'Erro ao cadastrar',
      passwordMismatch: 'As senhas não coincidem',
    },
    forgotPassword: {
      title: 'Redefinir senha',
      email: 'Digite seu e-mail',
      sendLink: 'Enviar link de redefinição',
      sending: 'Enviando...',
      sent: 'Enviado',
      backToLogin: 'Voltar ao login',
      toasts: {
        success: 'Link de redefinição de senha enviado com sucesso',
      },
    },
    resetPassword: {
      title: 'Redefinir senha',
      newPassword: 'Nova senha',
      confirmPassword: 'Confirmar senha',
      resetButton: 'Redefinir senha',
      resetting: 'Redefinindo...',
      resetDone: 'Redefinida',
      backToLogin: 'Voltar ao login',
      toasts: {
        success: 'Senha redefinida com sucesso',
      },
      errors: {
        missingOrInvalidToken:
          'Token de redefinição ausente ou inválido. Por favor, solicite um novo link.',
        passwordMismatch: 'As senhas não coincidem',
        passwordMinLength: 'A senha deve ter pelo menos 6 caracteres',
        resetFailed: 'Erro ao redefinir senha. Tente novamente.',
      },
    },
    tickets: {
      inbox: {
        sortAscending: 'Ascendente',
        sortDescending: 'Descendente',
      },
    },
    registerClient: {
      title: 'Cadastrar cliente',
      subtitle: 'Crie uma nova conta de cliente e defina o plano inicial.',
      steps: {
        company: 'Empresa',
        contact: 'Contato',
        plan: 'Plano e módulos',
      },
      toasts: {
        stepCompanyRequired: 'Preencha nome, email e telefone da empresa.',
        stepContactRequired: 'Preencha nome e email do contato.',
        success: 'Cliente cadastrado com sucesso.',
        error: 'Nao foi possivel cadastrar o cliente.',
      },
      industries: {
        retail: 'Varejo',
        restaurant: 'Restaurante',
        healthcare: 'Saude',
        education: 'Educacao',
        technology: 'Tecnologia',
        services: 'Servicos',
        ecommerce: 'Ecommerce',
        realEstate: 'Imobiliario',
        other: 'Outro',
      },
      company: {
        title: 'Dados da empresa',
        fields: {
          name: 'Nome da empresa',
          industry: 'Setor',
          email: 'Email da empresa',
          phone: 'Telefone da empresa',
          address: 'Endereco',
          website: 'Site',
        },
      },
      contact: {
        title: 'Pessoa de contato',
        fields: {
          name: 'Nome completo',
          position: 'Cargo',
          email: 'Email',
          phone: 'Telefone',
        },
      },
      plan: {
        title: 'Plano e faturamento',
        perMonth: '/mes',
        includes: {
          users: 'Usuarios',
          connections: 'Conexoes',
          queues: 'Areas',
        },
        billingCycle: 'Ciclo de cobranca',
        billingMonthly: 'Mensal',
        billingAnnual: 'Anual (2 meses gratis)',
      },
      addons: {
        title: 'Módulos adicionais',
        pricePerMonth: '$ {{amount}}/mes',
      },
      notes: {
        title: 'Observacoes internas',
        placeholder: 'Escreva observacoes para o time comercial...',
      },
      total: {
        label: 'Total estimado',
        perMonth: ' /mes',
        perYear: ' /ano',
      },
      buttons: {
        back: 'Voltar',
        next: 'Proximo',
        submit: 'Cadastrar cliente',
      },
    },
  },
  fr: {
    // Login
    login: {
      title: 'Klorum',
      subtitle: "Système CRM propulsé par l'IA",
      email: 'E-mail',
      password: 'Mot de passe',
      loginButton: 'Se connecter',
      noAccount: "Vous n'avez pas de compte ?",
      signupLink: "Inscrivez-vous ici",
      forgotPassword: 'Mot de passe oublié ?',
      errorLogin: 'Erreur de connexion',
      orContinueWith: 'Ou continuer avec',
      loginWithFacebook: 'Continuer avec Facebook',
      loginWithGoogle: 'Continuer avec Google',
      comingSoonFacebook: 'Bientôt : Connexion avec Facebook',
      comingSoonGoogle: 'Bientôt : Connexion avec Google',
    },
    landing: {
      badge: 'Plateforme commerciale 3D',
      title: 'Vendez, automatisez et evoluez sur une seule plateforme',
      subtitle: 'Centralisez WhatsApp, appels et suivi client avec controle en temps reel.',
      nav: {
        benefits: 'Avantages',
        market: 'Marche',
        pricing: 'Tarifs',
        contact: 'Contact',
      },
      quickPills: {
        speed: 'Reponses en secondes',
        control: 'Controle operationnel quotidien',
        conversión: 'Plus de ventes conclues',
      },
      servicesTitle: 'Services de base',
      services: {
        omnichannelTitle: 'Support omnicanal',
        omnichannelDescription: 'Unifiez chats et appels dans une seule boite.',
        automationTitle: 'Automatisation intelligente',
        automationDescription: 'Regles et flux pour repondre sans friction.',
        analyticsTitle: 'Analyse commerciale',
        analyticsDescription: 'Suivez performance et conversión en temps reel.',
        supportTitle: 'Controle operationnel',
        supportDescription: 'Assignez des taches et suivez chaque opportunite.',
      },
      benefitsTitle: 'Avantages cles',
      benefitsSubtitle: "Pilotez tout votre flux commercial avec moins d'etapes et des donnees claires.",
      benefits: {
        centralizedTitle: 'Operation centralisee',
        centralizedDescription: 'Messages, appels et taches dans la meme vue.',
        responseTitle: 'Reponse rapide',
        responseDescription: 'Modeles et declencheurs pour repondre immediatement.',
        followupTitle: 'Suivi constant',
        followupDescription: 'Rappels et statuts pour ne perdre aucune opportunite.',
        visibilityTitle: 'Visión en temps reel',
        visibilityDescription: 'Tableaux de bord pour activite, tunnel et conversión.',
        teamworkTitle: 'Travail en equipe',
        teamworkDescription: 'Repartissez les conversations et equilibrez la charge.',
        governanceTitle: 'Controle et securite',
        governanceDescription: 'Permissions par role et tracabilite complete.',
      },
      market: {
        title: 'Zone marketplace',
        subtitle: 'Activez des modules selon votre etape et payez seulement le necessaire.',
        items: {
          automationTitle: 'Flux et processus',
          automationDescription: 'Automatisez ventes, support et post-vente.',
          aiTitle: 'IA commerciale',
          aiDescription: 'Assistants, prompts et reponses suggerees.',
          integrationsTitle: 'Integrations',
          integrationsDescription: 'Connectez API, canaux et outils externes.',
          billingTitle: 'Facturation et plans',
          billingDescription: 'Gerez abonnements, renouvellements et croissance.',
        },
        ctaHint: 'Connectez-vous pour activer des modules depuis votre panel Marche.',
        ctaButton: 'Se connecter et activer',
      },
      actions: {
        login: "Entrer dans l'application",
        whatsapp: 'Contacter via WhatsApp',
        call: 'Appeler maintenant',
      },
      contactLabel: 'Contact Klorum : {{number}}',
      redirectHint: 'Tous les acces de la plateforme redirigent vers le login securise.',
      footer: {
        rights: 'Klorum {{year}}. Tous droits reserves.',
        note: 'Acces commercial via login securise.',
      },
    },
    // Signup
    signup: {
      title: 'Créer un compte',
      subtitle: 'Rejoignez Klorum',
      name: 'Nom complet',
      email: 'E-mail',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      company: 'Entreprise (optionnel)',
      phone: 'Téléphone (optionnel)',
      signupButton: "S'inscrire",
      hasAccount: 'Vous avez déjà un compte ?',
      loginLink: 'Connectez-vous ici',
      terms: 'En vous inscrivant, vous acceptez nos',
      termsLink: 'Conditions générales',
      and: 'et',
      privacyLink: 'Politique de confidentialité',
      errorSignup: "Erreur d'inscription",
      passwordMismatch: 'Les mots de passe ne correspondent pas',
    },
    forgotPassword: {
      title: 'Réinitialiser le mot de passe',
      email: 'Saisissez votre e-mail',
      sendLink: 'Envoyer le lien de réinitialisation',
      sending: 'Envoi...',
      sent: 'Envoyé',
      backToLogin: 'Retour à la connexion',
      toasts: {
        success: 'Lien de réinitialisation envoyé avec succès',
      },
    },
    resetPassword: {
      title: 'Réinitialiser le mot de passe',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      resetButton: 'Réinitialiser le mot de passe',
      resetting: 'Réinitialisation...',
      resetDone: 'Réinitialisé',
      backToLogin: 'Retour à la connexion',
      toasts: {
        success: 'Mot de passe réinitialisé avec succès',
      },
      errors: {
        missingOrInvalidToken:
          'Jeton de réinitialisation manquant ou invalide. Veuillez demander un nouveau lien.',
        passwordMismatch: 'Les mots de passe ne correspondent pas',
        passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
        resetFailed: 'Erreur lors de la réinitialisation du mot de passe. Veuillez réessayer.',
      },
    },
    tickets: {
      inbox: {
        sortAscending: 'Ascendant',
        sortDescending: 'Descendant',
      },
    },
    registerClient: {
      title: 'Enregistrer un client',
      subtitle: 'Creez un nouveau compte client et definissez le plan initial.',
      steps: {
        company: 'Entreprise',
        contact: 'Contact',
        plan: 'Plan et modules',
      },
      toasts: {
        stepCompanyRequired: "Renseignez le nom, l'email et le telephone de l'entreprise.",
        stepContactRequired: "Renseignez le nom et l'email du contact.",
        success: 'Client enregistre avec succes.',
        error: "Impossible d'enregistrer le client.",
      },
      industries: {
        retail: 'Commerce',
        restaurant: 'Restauration',
        healthcare: 'Sante',
        education: 'Education',
        technology: 'Technologie',
        services: 'Services',
        ecommerce: 'E-commerce',
        realEstate: 'Immobilier',
        other: 'Autre',
      },
      company: {
        title: "Informations de l'entreprise",
        fields: {
          name: "Nom de l'entreprise",
          industry: 'Secteur',
          email: "Email de l'entreprise",
          phone: "Telephone de l'entreprise",
          address: 'Adresse',
          website: 'Site web',
        },
      },
      contact: {
        title: 'Personne de contact',
        fields: {
          name: 'Nom complet',
          position: 'Poste',
          email: 'Email',
          phone: 'Telephone',
        },
      },
      plan: {
        title: 'Plan et facturation',
        perMonth: '/mois',
        includes: {
          users: 'Utilisateurs',
          connections: 'Connexions',
          queues: 'Domaines',
        },
        billingCycle: 'Cycle de facturation',
        billingMonthly: 'Mensuel',
        billingAnnual: 'Annuel (2 mois offerts)',
      },
      addons: {
        title: 'Modules additionnels',
        pricePerMonth: '$ {{amount}}/mois',
      },
      notes: {
        title: 'Notes internes',
        placeholder: "Ajoutez des notes pour l'equipe commerciale...",
      },
      total: {
        label: 'Total estime',
        perMonth: ' /mois',
        perYear: ' /an',
      },
      buttons: {
        back: 'Retour',
        next: 'Suivant',
        submit: 'Enregistrer le client',
      },
    },
  },
  it: {
    // Login
    login: {
      title: 'Klorum',
      subtitle: "Sistema CRM potenziato dall'IA",
      email: 'Email',
      password: 'Password',
      loginButton: 'Accedi',
      noAccount: 'Non hai un account?',
      signupLink: 'Registrati qui',
      forgotPassword: 'Hai dimenticato la password?',
      errorLogin: 'Errore di accesso',
      orContinueWith: 'Oppure continua con',
      loginWithFacebook: 'Continua con Facebook',
      loginWithGoogle: 'Continua con Google',
      comingSoonFacebook: 'Prossimamente: Accesso con Facebook',
      comingSoonGoogle: 'Prossimamente: Accesso con Google',
    },
    landing: {
      badge: 'Piattaforma commerciale 3D',
      title: "Vendi, automatizza e scala su un'unica piattaforma",
      subtitle: 'Centralizza WhatsApp, chiamate e follow-up con controllo in tempo reale.',
      nav: {
        benefits: 'Benefici',
        market: 'Mercato',
        pricing: 'Prezzi',
        contact: 'Contatto',
      },
      quickPills: {
        speed: 'Risposte in secondi',
        control: 'Controllo operativo giornaliero',
        conversión: 'Piu chiusure per team',
      },
      servicesTitle: 'Servizi base',
      services: {
        omnichannelTitle: 'Supporto omnicanale',
        omnichannelDescription: 'Unifica chat e chiamate in una sola inbox.',
        automationTitle: 'Automazione intelligente',
        automationDescription: 'Regole e flussi per rispondere senza attrito.',
        analyticsTitle: 'Analisi commerciale',
        analyticsDescription: 'Misura performance e conversióne in tempo reale.',
        supportTitle: 'Controllo operativo',
        supportDescription: 'Assegna attivita e segui ogni opportunita.',
      },
      benefitsTitle: 'Benefici chiave',
      benefitsSubtitle: 'Gestisci tutto il flusso commerciale con meno passaggi e dati chiari.',
      benefits: {
        centralizedTitle: 'Operazione centralizzata',
        centralizedDescription: 'Messaggi, chiamate e task nella stessa vista.',
        responseTitle: 'Risposta rápida',
        responseDescription: 'Template e trigger per rispondere subito.',
        followupTitle: 'Follow-up costante',
        followupDescription: 'Promemoria e stati per non perdere opportunita.',
        visibilityTitle: 'Visióne in tempo reale',
        visibilityDescription: 'Dashboard per attivita, funnel e conversióne giornaliera.',
        teamworkTitle: 'Lavoro di squadra',
        teamworkDescription: 'Distribuisci conversazioni e bilancia il carico agenti.',
        governanceTitle: 'Controllo e sicurezza',
        governanceDescription: 'Permessi per ruolo e tracciabilita di ogni azione.',
      },
      market: {
        title: 'Area marketplace',
        subtitle: 'Attiva moduli per ogni fase e paga solo cio che ti serve.',
        items: {
          automationTitle: 'Flussi e processi',
          automationDescription: 'Automatizza vendite, supporto e post-vendita.',
          aiTitle: 'IA commerciale',
          aiDescription: 'Assistenti, prompt e risposte suggerite.',
          integrationsTitle: 'Integrazioni',
          integrationsDescription: 'Collega API, canali e strumenti esterni.',
          billingTitle: 'Pagamenti e piani',
          billingDescription: 'Gestisci abbonamenti, rinnovi e crescita.',
        },
        ctaHint: 'Accedi per attivare moduli dal tuo pannello Mercato.',
        ctaButton: 'Accedi e attiva moduli',
      },
      actions: {
        login: "Entra nell'applicazione",
        whatsapp: 'Scrivi su WhatsApp',
        call: 'Chiama ora',
      },
      contactLabel: 'Contatto Klorum: {{number}}',
      redirectHint: 'Tutti gli accessi della piattaforma reindirizzano al login sicuro.',
      footer: {
        rights: 'Klorum {{year}}. Tutti i diritti riservati.',
        note: 'Accesso commerciale tramite login sicuro.',
      },
    },
    // Signup
    signup: {
      title: 'Crea account',
      subtitle: 'Unisciti a Klorum',
      name: 'Nome completo',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Conferma password',
      company: 'Azienda (opzionale)',
      phone: 'Teléfono (opzionale)',
      signupButton: 'Registrati',
      hasAccount: 'Hai già un account?',
      loginLink: 'Accedi qui',
      terms: 'Registrandoti, accetti i nostri',
      termsLink: 'Termini e condizioni',
      and: 'e',
      privacyLink: 'Informativa sulla privacy',
      errorSignup: 'Errore di registrazione',
      passwordMismatch: 'Le password non corrispondono',
    },
    forgotPassword: {
      title: 'Reimposta password',
      email: 'Inserisci la tua email',
      sendLink: 'Invia link di reimpostazione',
      sending: 'Invio...',
      sent: 'Inviato',
      backToLogin: 'Torna al login',
      toasts: {
        success: 'Link di reimpostazione inviato con successo',
      },
    },
    resetPassword: {
      title: 'Reimposta password',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma password',
      resetButton: 'Reimposta password',
      resetting: 'Reimpostazione...',
      resetDone: 'Reimpostata',
      backToLogin: 'Torna al login',
      toasts: {
        success: 'Password reimpostata con successo',
      },
      errors: {
        missingOrInvalidToken:
          'Token di reimpostazione mancante o non valido. Richiedi un nuovo link.',
        passwordMismatch: 'Le password non corrispondono',
        passwordMinLength: 'La password deve avere almeno 6 caratteri',
        resetFailed: 'Errore durante la reimpostazione della password. Riprova.',
      },
    },
    tickets: {
      inbox: {
        sortAscending: 'Ascendente',
        sortDescending: 'Discendente',
      },
    },
    registerClient: {
      title: 'Registra cliente',
      subtitle: 'Crea un nuovo account cliente e imposta il piano iniziale.',
      steps: {
        company: 'Azienda',
        contact: 'Contatto',
        plan: 'Piano e moduli',
      },
      toasts: {
        stepCompanyRequired: "Compila nome, email e teléfono dell'azienda.",
        stepContactRequired: 'Compila nome ed email del contatto.',
        success: 'Cliente registrato con successo.',
        error: 'Impossibile registrare il cliente.',
      },
      industries: {
        retail: 'Retail',
        restaurant: 'Ristorante',
        healthcare: 'Sanita',
        education: 'Istruzione',
        technology: 'Tecnologia',
        services: 'Servizi',
        ecommerce: 'Ecommerce',
        realEstate: 'Immobiliare',
        other: 'Altro',
      },
      company: {
        title: 'Dati azienda',
        fields: {
          name: 'Nome azienda',
          industry: 'Settore',
          email: 'Email aziendale',
          phone: 'Teléfono aziendale',
          address: 'Indirizzo',
          website: 'Sito web',
        },
      },
      contact: {
        title: 'Referente',
        fields: {
          name: 'Nome completo',
          position: 'Ruolo',
          email: 'Email',
          phone: 'Teléfono',
        },
      },
      plan: {
        title: 'Piano e fatturazione',
        perMonth: '/mese',
        includes: {
          users: 'Utenti',
          connections: 'Connessioni',
          queues: 'Aree',
        },
        billingCycle: 'Ciclo di fatturazione',
        billingMonthly: 'Mensile',
        billingAnnual: 'Annuale (2 mesi gratis)',
      },
      addons: {
        title: 'Moduli aggiuntivi',
        pricePerMonth: '$ {{amount}}/mese',
      },
      notes: {
        title: 'Note interne',
        placeholder: 'Scrivi note per il team commerciale...',
      },
      total: {
        label: 'Totale stimato',
        perMonth: ' /mese',
        perYear: ' /anno',
      },
      buttons: {
        back: 'Indietro',
        next: 'Avanti',
        submit: 'Registra cliente',
      },
    },
  },
};

export const languageNames = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  it: 'Italiano',
};
